<form [formGroup]="form">
    <div fxLayout="column" class="ma-1">
        <div>
            <mat-form-field class="full-width">
                <mat-label>{{ 'sipphone_config_template.content.model'|translate }}</mat-label>
                
                <sipphone-phone-model-input
                    formControlName="model"></sipphone-phone-model-input>

                <mat-error [flexFormControlError]="form.get('model')"
                    *ngIf="!form.get('model').valid && form.get('model').touched"></mat-error>
            </mat-form-field>
        </div>
        
        <div>
            <mat-form-field class="full-width">
                <mat-label>{{ 'sipphone_config_template.content.version'|translate }}</mat-label>

                <sipphone-phone-version-input
                    [phoneModel]="form.get('model').value?.value"
                    formControlName="version"></sipphone-phone-version-input>

                <mat-error [flexFormControlError]="form.get('version')"
                    *ngIf="!form.get('version').valid && form.get('version').touched"></mat-error>
            </mat-form-field>
        </div>
    </div>
  </form>
  